export enum TeleconsultationCardType {
  CHAT = 'C',
  DOCUMENT = 'D',
  VIDEO = 'V'
}

export enum TeleconsultationRecordsIcons {
  CHAT = '/static/assets/avatars/DLS_ConversationText_48.svg',
  VIDEO = '/static/assets/avatars/DLS_MoviecontrolPlay_Circle.svg',
  DOCUMENT = '/static/assets/avatars/DLS_DocumentText_48.svg'
}

export enum TeleconsultationRecordsLabels {
  CHAT = 'patient.label.chat-teleconsultation',
  VIDEO = 'patient.label.video',
  DOCUMENT = 'profile-change.document'
}